export default class CardExpiryService {
    private readonly expiryPattern = /^(\d{1,2})\s*\/\s*(\d{4}|\d{2})$/;

    private getMonthYearComponent(match: RegExpExecArray): number[] {
        // Group index, 0 is whole match, 1 is for month, 2 is for year.
        // In JavaScript, we don't have built in group capture with name.
        const month = parseInt(match[1], 10);
        const year = this.normalizeYear(match);

        return [month, year];
    }

    private normalizeYear(match: RegExpExecArray): number {
        let year = match[2];

        if (year.length === 2) {
            const yearPrefix = new Date().getFullYear().toString().substring(0, 2);
            year = `${yearPrefix}${year}`;
        }

        return parseInt(year, 10);
    }

    private _month: number = -1;
    public get month(): number {
        return this._month;
    }

    private _year: number = -1;
    public get year(): number {
        return this._year;
    }

    private _isExpired: boolean = false;
    public get isExpired() {
        return this._isExpired;
    }

    private _isValid: boolean = false;
    public get isValid() {
        return this._isValid;
    }

    private _errorMessage: string = '';
    public get errorMessage() {
        return this._errorMessage;
    }

    public createCardExpiry(value: string) {
        const match = this.expiryPattern.exec(value) as RegExpExecArray;
        if (!match) {
            this._errorMessage = `Card expiry with value '${value}' is not in MM/YYYY or MM/YY format.`;
            return;
        }

        const [month, year] = this.getMonthYearComponent(match);
        if (month < 1 || month > 12) {
            this._errorMessage = `Card expiry month is invalid.`;
            return;
        }

        if (this.isCardExpired(year)) {
            this._isExpired = true;
            this._errorMessage = `Card expiry with value '${value}' is expired.`;
        }

        this._isValid = true;
        this._month = month;
        this._year = year;
    }

    private isCardExpired(year: number): boolean {
        // Get current year from customer's computer time
        const currentYear = new Date().getFullYear();
        // We prevent the case that customer's computer time is faster than actual time
        // by minus 1 year and be optimistic to not return validation error.
        const adjustCurrentYear = currentYear - 1;
        if (year < adjustCurrentYear) {
            return true;
        }

        return false;
    }
}